<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M8.10187 11.9111C8.43918 11.9111 8.71255 11.6378 8.71255 11.3004L8.71256 1.61088C8.71256 1.27357 8.43918 1.0002 8.10187 1.0002C7.76456 1.0002 7.49118 1.27357 7.49118 1.61088L7.49118 11.3004C7.49118 11.6378 7.76456 11.9111 8.10187 11.9111Z" class="icon-fill"/>
      <path d="M4.30578 8.59164L7.6849 11.7469C7.91962 11.9659 8.28378 11.9659 8.5185 11.7469L11.8976 8.59164C12.1441 8.36142 12.1576 7.97505 11.9274 7.72855C11.8073 7.5997 11.6442 7.53455 11.481 7.53455C11.3316 7.53455 11.1819 7.58889 11.0643 7.69883L8.10184 10.465L5.1394 7.69883C4.8925 7.46861 4.50634 7.48205 4.27631 7.72855C4.04625 7.97505 4.05928 8.36142 4.30578 8.59164Z" class="icon-fill"/>
      <path d="M14.2087 5.21094H10.9517C10.6144 5.21094 10.341 5.48431 10.341 5.82163C10.341 6.15894 10.6144 6.43231 10.9517 6.43231H13.598V14.7784H2.40204V6.43231H5.04835C5.38566 6.43231 5.65904 6.15894 5.65904 5.82163C5.65904 5.48431 5.38566 5.21094 5.04835 5.21094H1.79135C1.45404 5.21094 1.18066 5.48431 1.18066 5.82163V15.3891C1.18066 15.7264 1.45404 15.9998 1.79135 15.9998H14.2087C14.546 15.9998 14.8194 15.7264 14.8194 15.3891V5.82163C14.8194 5.48434 14.546 5.21094 14.2087 5.21094Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" class="icon-fill"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'download'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>